import { render, staticRenderFns } from "./BaseBackground.vue?vue&type=template&id=7ca3703c&scoped=true&"
var script = {}
import style0 from "./BaseBackground.vue?vue&type=style&index=0&id=7ca3703c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca3703c",
  null
  
)

export default component.exports